import { render, staticRenderFns } from "./student-login.vue?vue&type=template&id=3c9a4948&lang=pug&"
import script from "./student-login.vue?vue&type=script&lang=js&"
export * from "./student-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports